import { Link } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";
import EmptyState from "@/components/feature/EmptyState";
import { usePageMeta } from "@/hooks/usePageMeta";
import { specials } from "@/mocks/specials";

export default function SpecialList() {
  usePageMeta({
    title: "影评专题 - 生活中的玛丽",
    description:
      "生活中的玛丽影评专题页，汇聚华语悬疑剧、科幻时间哲学、韩国现实主义剧集等系列深度长评，带你读懂影视作品背后的故事。",
    keywords: "生活中的玛丽,影评专题,影视评论,深度长评,影视解读",
  });

  return (
    <div className="w-full">
      <div className="bg-primary-500">
        <div className="w-full px-4 md:px-8 py-8 md:py-12">
          <div className="text-background-300">
            <Breadcrumb items={[{ label: "影评专题" }]} />
          </div>
          <h1 className="mt-4 font-heading font-black text-3xl md:text-4xl text-background-50">影评专题</h1>
          <p className="mt-3 text-sm md:text-base text-background-200 max-w-2xl leading-relaxed">
            我们围绕一个主题，集合多篇长评与解读，帮你跳出单部作品的视角，看到类型、时代与创作者之间更深的联系。
          </p>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-8 md:py-12">
        {specials.length === 0 ? (
          <div className="bg-background-50 rounded-lg border border-background-200">
            <EmptyState icon="ri-book-2-line" title="暂无影评专题" description="专题内容正在准备中，敬请期待。" />
          </div>
        ) : (
          <div className="space-y-8">
            {specials.map((special) => (
              <article
                key={special.id}
                className="bg-background-50 rounded-lg border border-background-200 overflow-hidden md:flex"
              >
                <Link
                  to={`/special/${special.id}`}
                  className="block md:w-[42%] shrink-0 relative aspect-[16/9] md:aspect-auto md:min-h-[260px] overflow-hidden bg-background-100 cursor-pointer"
                >
                  <img
                    src={special.cover}
                    alt={`${special.title} 专题封面`}
                    title={`${special.title} - 影评专题`}
                    className="w-full h-full object-cover object-top transition-transform duration-700 hover:scale-105"
                  />
                </Link>
                <div className="p-5 md:p-7 flex flex-col flex-1">
                  <div className="flex flex-wrap items-center gap-2 mb-3">
                    {special.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-[11px] font-medium"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
                    <Link to={`/special/${special.id}`} className="hover:text-primary-500 transition-colors cursor-pointer">
                      {special.title}
                    </Link>
                  </h2>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">
                    {special.intro}
                  </p>
                  <div className="mt-5 flex flex-wrap items-center justify-between gap-3">
                    <div className="flex items-center gap-4 text-xs text-foreground-500">
                      <span className="flex items-center gap-1">
                        <i className="ri-user-line"></i>
                        {special.author}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-calendar-line"></i>
                        {special.date}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-file-list-3-line"></i>
                        {special.articles.length} 篇
                      </span>
                    </div>
                    <Link
                      to={`/special/${special.id}`}
                      className="h-10 px-4 rounded-md bg-accent-500 hover:bg-accent-600 text-background-50 text-sm font-medium whitespace-nowrap flex items-center gap-1.5 transition-colors cursor-pointer"
                    >
                      进入专题
                      <i className="ri-arrow-right-line"></i>
                    </Link>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}